import axios from '../axios/axios';
import {
  PPA_APPLICATION_DATA_REQUEST,
  PPA_APPLICATION_DATA_SUCCESS,
  PPA_APPLICATION_DATA_FAIL,
} from '../constants/ppaApplicationConstants';

export const ppaApplicationAction = () => async (dispatch) => {
  try {
    dispatch({ type: PPA_APPLICATION_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s23',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: PPA_APPLICATION_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: PPA_APPLICATION_DATA_FAIL,
      payload: error,
    });
  }
};
